import gql from 'graphql-tag';

export default gql`
mutation ($id: String!, $name: String!, $advertiserId: String!, $status: ReportStatus!, $version: Int!, $file: S3ObjectInput!) {
    createReport (input: {
        id: $id
        name: $name
        advertiserId: $advertiserId,
        status: $status
        version: $version,
        file: $file
    }) {
        __typename
        id
        name
        advertiserId
        status
        version       
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Reports/NewMutation.js